import { render, staticRenderFns } from "./dialog-cache.vue?vue&type=template&id=64a85b68&scoped=true&"
import script from "./dialog-cache.vue?vue&type=script&lang=js&"
export * from "./dialog-cache.vue?vue&type=script&lang=js&"
import style0 from "./dialog-cache.vue?vue&type=style&index=0&id=64a85b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a85b68",
  null
  
)

export default component.exports